import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip, getShippingLabelStatusInfo, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

import ParcelCardCarrier from './ParcelCardCarrier/ParcelCardCarrier'
import ParcelCardClaim from './ParcelCardClaim/ParcelCardClaim'
import ParcelCardMenu from './ParcelCardMenu/ParcelCardMenu'
import ParcelCardPendingAlerts from './ParcelCardPendingAlerts/ParcelCardPendingAlerts'
import ParcelCardService from './ParcelCardService/ParcelCardService'
import { itemsLabelKeys } from './constants'
import {
  getCountLabelKey,
  getFormattedCreatedAt,
  getParcelCardTypeInfo,
  hasActiveClaim,
  hasPendingAlerts,
  isCancelledParcel,
} from './helpers'
import * as Styles from './styles'

const ParcelCard = ({ parcel, onViewParcelDetail, orderTrackingPageUrl, displayCarrierTrackingPageAction }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const typeInfo = getParcelCardTypeInfo(parcel)
  const statusInfo = getShippingLabelStatusInfo()[parcel.status]
  const isCancelled = isCancelledParcel(parcel)
  const contentColor = isCancelled ? theme.colors.text.muted : theme.colors.text.default
  const formattedCreatedAt = getFormattedCreatedAt(parcel.created_at, i18n.language, info?.selectedStore?.timezone)
  const itemsLabel = t(getCountLabelKey(parcel.items_quantity, itemsLabelKeys), { count: parcel.items_quantity })

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.TitleContainer>
          <typeInfo.Icon size={20} color={contentColor} />
          <Styles.Title type="bodyMMedium" color={contentColor}>
            {t(typeInfo.labelKey, { number: parcel.index })}
          </Styles.Title>
          {hasPendingAlerts(parcel) && <ParcelCardPendingAlerts pendingAlertsCount={parcel.pending_alerts_count} />}
        </Styles.TitleContainer>
        <Styles.Actions>
          <Chip
            label={
              <Text type="bodySMedium" color={statusInfo.color}>
                {t(statusInfo.label)}
              </Text>
            }
            Icon={statusInfo.Icon}
            color={statusInfo.color}
            backgroundColor={statusInfo.backgroundColor}
          />
          <ParcelCardMenu
            onViewParcelDetail={onViewParcelDetail}
            orderTrackingPageUrl={orderTrackingPageUrl}
            carrierTrackingPageUrl={parcel.tracking_url}
            displayCarrierTrackingPageAction={displayCarrierTrackingPageAction}
          />
        </Styles.Actions>
      </Styles.Header>
      {!isCancelled && (
        <>
          <ParcelCardCarrier carrier={parcel.carrier} trackingNumber={parcel.tracking_number} />
          <ParcelCardService
            methodName={parcel.method?.name}
            isReveniContract={parcel.method?.carrier?.is_reveni_contract}
          />
        </>
      )}
      <Styles.Footer>
        <Text type="bodyMRegular" color={contentColor}>
          {itemsLabel}
        </Text>
        <Text type="bodySRegular" color={theme.colors.text.subtle}>
          {formattedCreatedAt}
        </Text>
      </Styles.Footer>
      {hasActiveClaim(parcel) && <ParcelCardClaim status={parcel.active_claim.status} />}
    </Styles.Container>
  )
}

export default ParcelCard
